import { UnitGroup } from "@/types";

export const useUnitDataAttributes = (unitGroup: UnitGroup) => {
    const facilityId = unitGroup.representative_unit.facility_id;
    const unitId = unitGroup.representative_unit.id;
    const features = unitGroup.representative_unit?.features
        ?.map((feature) => feature.slug)
        .join(",");
    const categories = unitGroup.representative_unit.category.slug;

    return {
        "data-facility-id": facilityId,
        "data-unit-id": unitId,
        "data-features": features,
        "data-categories": categories,
    };
};
